<template>
  <div id="st-content-graphic" class="st-content-graphic scroll-content" :style="scrollContentStyle" itemscope itemtype="http://schema.org/NewsArticle">
    <meta itemprop="datePublished" v-if="date" :content="date" />
    <st-menu></st-menu>
    <!-- route outlet -->
    <!-- component matched by the route will render here -->
    <transition>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
    <st-footer ref="footer"></st-footer>
    <transition name="fade">
      <st-loading v-if="$loading.isLoading" />
    </transition>
    <div class="icon-templates">
      <div class="img-container" v-for="type in iconTypes" :key="type">
        <st-get-svg
          rootFolder="project/people"
          :platform="type"
          @onGetSvg="templateOnReady[type]">
        </st-get-svg>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import StMenu from './menu/index.vue'
import StFooter from './footer/index.vue'
import StLoading from './StLoading.vue'
import StGetSvg from './artefacts/SvgFolder/StGetSvg.vue'

const iconTypes = [
  'man',
  'woman',
  'boy',
  'girl',
  'baby',
  'mansenior',
  'womansenior'
]

const templateOnReady = {}
const templateReady = {}
iconTypes.forEach((type, i) => {
  templateReady[type] = new Promise(resolve => {
    templateOnReady[type] = resolve
  })
})

const graphIcons = iconTypes.map(type => {
  const $image = new Image()
  $image.src = require(`images/project/people/${type}-chart.png`)
  return $image
})

export default {
  components: {StMenu, StFooter, StLoading, StGetSvg},
  provide: {
    graphIcons,
    iconTemplateReady: templateReady
  },
  data () {
    return {
      scrollContentStyle: {
        'padding-bottom': 0
      }
    }
  },
  computed: {
    ...mapState(['date']),
    iconTypes: () => iconTypes,
    templateOnReady: () => templateOnReady
  },
  methods: {
    handleResize () {
      this.scrollContentStyle['padding-bottom'] = this.$refs.footer.$el.getBoundingClientRect().height + 'px'
    }
  },
  mounted () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
  }
}
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 1s;
}

.fade-leave-to {
  opacity: 0;
}

.icon-templates {
  height: 0;
  overflow: hidden;
  visibility: hidden;

  .img-container {
    width: 140px;
  }
}
</style>
